import React, { useState } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import { Col, Row } from './Style';

const Preview = () => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <Accordion style={{ width: '100%' }}>
      <Accordion.Title
        active={!collapsed}
        onClick={() => setCollapsed(!collapsed)}
      >
        <Icon name="dropdown" />
        미리보기
      </Accordion.Title>
      <Accordion.Content active={!collapsed}>
        <Col>
          <Row>
            <img src="/race/필터이미지1.png" width={350} alt="필터이미지1" />
          </Row>
        </Col>
      </Accordion.Content>
    </Accordion>
  );
};

export default Preview;
